import React from 'react'
import './Input.scss'

export function Input({
  value,
  onChange,
  placeholder = 'Text...'
}: {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
}) {
  const [text, setText] = React.useState(value ?? '')
  const textRef = React.useRef(text)
  textRef.current = text
  React.useEffect(() => {
    if (value != null && value !== textRef.current) {
      setText(value)
    }
  }, [value])

  const updateText = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setText(e.target.value)
      onChange?.(e.target.value)
    },
    [onChange]
  )

  return (
    <input
      type="text"
      value={text || ''}
      placeholder={placeholder}
      onChange={updateText}
    />
  )
}
